import apiClient from '@u/apiClient'

export default {
  setPeppolProvider({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.id}/peppol/provider`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  registerCompanyToBcSolutions({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.id}/peppol/bcsolutions/register`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getBcSolutionsPeppolStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`company/${payload.id}/peppol/bcsolutions/status`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  restartBcSolutionsOnboarding({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.id}/peppol/bcsolutions/restart`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
